import { createRoot } from "react-dom/client";
import AvmEstimateWidget from "./AvmEstimateWidget";
import SearchMapIsland from "./SearchMapIsland";

// Registry of mountable React islands. Add a component here and reference it by
// this key from a template via the `connect_island` helper:
//   <%= connect_island "AvmEstimateWidget", agent_name: theme.agent_name %>
//
// Future Connect islands (map draw, CMA builder UI, embedded chat widget) plug
// in the same way — keyed by name, hydrated in place. No SPA router.
const REGISTRY = {
  AvmEstimateWidget,
  SearchMapIsland,
};

// Hydrate every [data-connect-island] under `root` exactly once. Unknown island
// names warn (rather than throw) so one bad mount can't blank the whole page.
export function mountIslands(root = document) {
  const nodes = root.querySelectorAll("[data-connect-island]");
  nodes.forEach((el) => {
    if (el.dataset.connectMounted === "true") return;

    const name = el.dataset.connectIsland;
    const Component = REGISTRY[name];
    if (!Component) {
      console.warn(`[connect] no island registered for "${name}"`);
      return;
    }

    let props = {};
    const raw = el.dataset.connectProps;
    if (raw) {
      try {
        props = JSON.parse(raw);
      } catch (e) {
        console.warn(`[connect] invalid props for island "${name}"`, e);
      }
    }

    el.dataset.connectMounted = "true";
    el.textContent = ""; // clear any SSR/no-JS fallback before hydrating
    createRoot(el).render(<Component {...props} />);
  });
}
